































import Popup from '@/views/organisms/Popup.vue'
import BlueButton from '@/views/atoms/BlueButton.vue'
import ApiClient from '@/common/api'
import store from '@/store'
import TextDatePicker from '@/views/molecules/NoStoreTextDatePicker.vue'
import Radio from '@/views/atoms/Radio.vue'
import SelectBox from '@/views/atoms/SelectBox.vue'
import Global from '@/common/global.js'

export default
  components: {
    Popup
    BlueButton
    TextDatePicker
    Radio
    SelectBox
  }

  props:
    id: 
      type: String
      default: ''
    date: 
      type: String
      default: ''
    timeStyle: 
      type: String
      default: ''

  data: ()->
    d: @date
    hours: '00'
    minutes: '00'
    time_style: @timeStyle
    hoursList: Global.hoursList()
    minutesList: Global.minutes()

  created:() ->
    if @date
      @d = @date.split(' ')[0]
      if @date.split(' ')[1]
        time = @date.split(' ')[1].split(':')
        if time[1]
          @hours = time[0]
          @minutes = time[1]

  methods: {
    close_popup: (e) ->
      @$emit('close_popup')
    change: (v) ->
      @d = v.val
      if !@d
        @time_style = '3'
    changeRadio: (v) ->
      @time_style = v
    changeHours: (v) ->
      @hours = v.val
    changeMinutes: (v) ->
      @minutes = v.val
    save_click: () ->
      if @d
        if @time_style == '0'
          datetime = @d + ' ' + @hours + ':' + @minutes
        else if @time_style == '1'
          datetime = @d + ' 00:00'
        else if @time_style == '2'
          datetime = @d + ' 12:00'
        else if @time_style == '3'
          datetime = @d + ' 23:59'
        else
          datetime = @d
      else
        datetime = null
        @time_style = '3'
      param = 
        id: @id
        cut_datetime: datetime
        time_style: @time_style
      @$emit('click', param)
  }
